// extracted by mini-css-extract-plugin
export default {"button":"SIT_button__uHoHC"};